import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { PlanLocalisationApi } from "../../../../api";
import { ERoutes } from "../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { LocalisationClasseDetailPage } from "./LocalisationClasseDetailPage";

export interface ILocalisationClasseItemPageProps {}

export const LocalisationClasseItemPage: React.FunctionComponent<ILocalisationClasseItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();

  const api = useApiService(PlanLocalisationApi);

  const [displayName] = useApiEffect(() => api.planLocalisationGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.LocalisationsClasses), route: ERoutes.localisationClasse },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsLocalisationClasse"
        onChange={newTabId => history.push(`${ERoutes.localisationClasse}/${id}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.localisationClasse} />
        <Tab id="detail" title={t(ETLCodes.Detail)} panel={<LocalisationClasseDetailPage />} />
      </ProtectedTabs>
    </PageBase>
  );
};
